import { z } from 'zod';
// Adapted from https://github.com/colinhacks/zod/discussions/2081#discussioncomment-5077959
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function createRequiredRecord(keysEnum, valueSchema) {
    return z.object(Object.fromEntries(keysEnum.options.map((k) => [k, valueSchema])));
}
